<template>
  <path d="M14.238 8.286v1.429c0 0.394-0.32 0.714-0.714 0.714h-9.048c-0.394 0-0.714-0.32-0.714-0.714v-1.429c0-0.394 0.32-0.714 0.714-0.714h9.048c0.394 0 0.714 0.32 0.714 0.714z"></path>
</template>
